//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'codemirror/lib/codemirror.css';
import CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/mode/javascript/javascript';
import { deepParseFn, toJSON } from '../utils/index';
import { deepCopy } from '@form-create/utils/lib/deepextend';
export default {
  name: 'Struct',
  props: {
    value: [Object, Array],
    title: {
      type: String,
      default: '编辑数据'
    },
    defaultValue: {
      require: false
    },
    validate: Function
  },
  data: function data() {
    return {
      editor: null,
      visible: false,
      err: false,
      oldVal: null
    };
  },
  watch: {
    value: function value() {
      this.load();
    },
    visible: function visible(n) {
      if (n) {
        this.load();
      } else {
        this.err = false;
      }
    }
  },
  methods: {
    load: function load() {
      var _this = this;
      //const val = toJSON(this.value ? deepParseFn(deepCopy(this.value)) : this.defaultValue);
      var val = toJSON(this.value ? deepCopy(this.value) : this.defaultValue);
      this.oldVal = val;
      this.$nextTick(function () {
        _this.editor = CodeMirror(_this.$refs.editor, {
          lineNumbers: true,
          mode: 'javascript',
          gutters: ['CodeMirror-lint-markers'],
          lint: true,
          line: true,
          tabSize: 2,
          lineWrapping: true,
          value: val || ''
        });
        _this.editor.on('blur', function () {
          _this.err = _this.editor.state.lint && _this.editor.state.lint.marked.length > 0;
        });
      });
    },
    onOk: function onOk() {
      if (this.err) return;
      var str = this.editor.getValue();
      var val;
      try {
        val = eval('(function (){return ' + str + '}())');
      } catch (e) {
        this.err = " (".concat(e, ")");
        return;
      }
      if (this.validate && false === this.validate(val)) {
        this.err = true;
        return;
      }
      this.visible = false;
      if (toJSON(val, null, 2) !== this.oldVal) {
        this.$emit('input', val);
      }
    }
  }
};